// src/index.ts
var TCFData;
var defaultPurposes = Array.from({ length: 11 }, (_, i) => i + 1);
var { resolveConsentSignal, consentSignalPromise } = (() => {
  let resolveConsentSignal2;
  const consentSignalPromise2 = new Promise((resolve) => {
    resolveConsentSignal2 = resolve;
  });
  return { resolveConsentSignal: resolveConsentSignal2, consentSignalPromise: consentSignalPromise2 };
})();
var consentSignalReady = (tcData) => {
  const { gdprApplies, cmpStatus, tcString } = tcData;
  return !!(cmpStatus === "loaded" && gdprApplies && tcString);
};
var tcfEventCallback = (tcData, success) => {
  if (!success) {
    console.error("TCF - failed to process addEventListener command");
  }
  if (tcData.cmpStatus === "error") {
    console.error("TCF - CMP error");
  }
  TCFData = tcData;
  if (consentSignalReady(tcData)) {
    resolveConsentSignal();
  }
};
var hasPurposesConsented = (requiredPurposes) => {
  const purposes = TCFData.purpose?.consents ?? {};
  return requiredPurposes.every((purposeId) => purposes[purposeId]);
};
var hasVendorConsented = (vendorId) => {
  const iabVendorConsents = TCFData.vendor?.consents ?? {};
  return !!iabVendorConsents?.[vendorId];
};
var getTCFString = async () => {
  await consentSignalPromise;
  return TCFData.tcString;
};
var isVendorConsented = (vendorId, requiredPurposes = defaultPurposes) => {
  if (!TCFData.gdprApplies) {
    return true;
  }
  const vendorIds = Array.isArray(vendorId) ? vendorId : [vendorId];
  const allVendorsConsented = vendorIds.every(hasVendorConsented);
  const purposesConsented = hasPurposesConsented(requiredPurposes);
  return allVendorsConsented && purposesConsented;
};
var waitForVendorConsent = async (vendorId, purposes = defaultPurposes) => {
  await consentSignalPromise;
  return isVendorConsented(vendorId, purposes);
};
var waitForTCF = () => {
  return new Promise((resolve) => {
    const loop = () => {
      return typeof globalThis.__tcfapi === "function" ? resolve() : setTimeout(loop, 10);
    };
    loop();
  });
};
var init = async () => {
  await waitForTCF();
  globalThis.__tcfapi("addEventListener", 2, tcfEventCallback);
};
init();
export {
  waitForVendorConsent,
  isVendorConsented,
  init,
  getTCFString,
  defaultPurposes
};

//# debugId=29C40D96A0D064AA64756E2164756E21
